export default "__VITE_ASSET__u09R1FJ0__"